var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("span", { staticClass: "dashboards-maker--aside__title" }, [
        _vm._v(_vm._s(_vm.titleLabel))
      ]),
      _vm._v(" "),
      _vm._t("default"),
      _vm._v(" "),
      _c("p", { staticClass: "dashboards-maker--aside__footer" }, [
        _vm._v("\n    " + _vm._s(_vm.instructionsLabel) + "\n  ")
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }